
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/api';
import axios from 'axios';
import { api_url } from '../../utils/utils'
import { paginationTotal } from '../../utils/pagination'
// 🔥 ADMIN PANEL - Seller idarəetməsi

// Get all sellers (admin)
export const get_sellers_admin = createAsyncThunk(
    'adminSeller/get_sellers_admin',
    async ({ page, searchValue, parPage }, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // };
        try {
            const params = new URLSearchParams({ page, searchValue: searchValue || '', parPage });
            const { data } = await axios.get(`${api_url}/api/admin/get-sellers?${params.toString()}`, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Ban seller (admin)
export const ban_seller = createAsyncThunk(
    'adminSeller/ban_seller',
    async ({ sellerId, reason }, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // };
        try {
            const { data } = await api.post(`/admin/ban-seller`, { sellerId, reason }, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Unban seller (admin)
export const unban_seller = createAsyncThunk(
    'adminSeller/unban_seller',
    async (sellerId, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // };
        try {
            const { data } = await api.post(`/admin/unban-seller`, { sellerId, }, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Delete seller (admin)
export const delete_seller = createAsyncThunk(
    'adminSeller/delete_seller',
    async (sellerId, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // };
        try {
            const { data } = await api.delete(`/admin/delete-seller/${sellerId}`, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Get security logs (admin)
export const get_security_logs = createAsyncThunk(
    'adminSeller/get_security_logs',
    async ({ userId, userType, action, page, limit }, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // };
        try {
            const params = new URLSearchParams();
            if (userId) params.append('userId', userId);
            if (userType) params.append('userType', userType);
            if (action) params.append('action', action);
            if (page) params.append('page', page);
            if (limit) params.append('limit', limit);

            const { data } = await axios.get(`${api_url}/api/admin/security-logs?${params.toString()}`, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// 🔥 KÖHNƏ SELLER FUNKSIYALARI (saxlanılır)

export const get_seller_request = createAsyncThunk(
    'seller/get_seller_request',
    async ({ parPage, page, searchValue }, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // };
        try {
            const params = new URLSearchParams({ page, searchValue: searchValue || '', parPage });
            const { data } = await axios.get(`${api_url}/api/request-seller-get?${params.toString()}`, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const get_seller = createAsyncThunk(
    'seller/get_seller',
    async (sellerId, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // };
        try {
            const { data } = await axios.get(`${api_url}/api/get-seller/${sellerId}`, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const get_admin_seller_products = createAsyncThunk(
    'seller/get_admin_seller_products',
    async ({ sellerId, page = 1, limit = 5, searchValue = '', status = '' }, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     },
        //     withCredentials: true
        // };
        try {
            const params = new URLSearchParams({ page, limit, searchValue, status });
            const { data } = await axios.get(`${api_url}/api/admin/sellers/${sellerId}/products?${params.toString()}`, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Seller məhsulları yüklənmədi' });
        }
    }
);

export const admin_delete_product = createAsyncThunk(
    'seller/admin_delete_product',
    async (productId, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     },
        //     withCredentials: true
        // };
        try {
            const { data } = await api.delete(`/admin/products/${productId}`, { withCredentials: true });
            return fulfillWithValue({ ...data, productId });
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Məhsul deaktiv edilmədi' });
        }
    }
);

export const seller_status_update = createAsyncThunk(
    'seller/seller_status_update',
    async (info, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // };
        try {
            const { data } = await api.post(`/seller-status-update`, info, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const get_active_sellers = createAsyncThunk(
    'seller/get_active_sellers',
    async ({ parPage, page, searchValue }, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // };
        try {
            const params = new URLSearchParams({ page, searchValue: searchValue || '', parPage });
            const { data } = await axios.get(`${api_url}/api/get-sellers?${params.toString()}`, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const get_deactive_sellers = createAsyncThunk(
    'seller/get_deactive_sellers',
    async ({ parPage, page, searchValue }, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // };
        try {
            const params = new URLSearchParams({ page, searchValue: searchValue || '', parPage });
            const { data } = await axios.get(`${api_url}/api/get-deactive-sellers?${params.toString()}`, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
export const create_stripe_connect_account = createAsyncThunk(
    'seller/create_stripe_connect_account',
    async (_, { getState }) => {
        try {
            const { data: { url } } = await axios.get(`${api_url}/api/payment/create-stripe-connect-account`, { withCredentials: true })
            window.location.href = url
            // return fulfillWithValue(data)
        } catch (error) {
            //return rejectWithValue(error.response.data)
        }
    }
)

export const active_stripe_connect_account = createAsyncThunk(
    'seller/active_stripe_connect_account',
    async (activeCode, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // }
        try {
            const { data } = await api.put(`/payment/active-stripe-connect-account/${activeCode}`, {}, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
export const get_activity_logs = createAsyncThunk(
    'seller/get_activity_logs',
    async (params, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // };
        try {
            const { data } = await axios.get(`${api_url}/api/admin/activity-logs`, { params, ...{ withCredentials: true } });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: 'Failed to fetch activity logs' }
            );
        }
    }
);

export const sellerReducer = createSlice({
    name: 'seller',
    initialState: {
        successMessage: '',
        errorMessage: '',
        loader: false,
        sellers: [],
        totalSeller: 0,
        seller: '',
        // 🆕 Admin panel üçün
        securityLogs: [],
        activityLogs: [],
        totalActivityLogs: 0,
        totalLogs: 0,
        sellerProducts: [],
        sellerProductsPagination: null,
        sellerProductsTotal: 0
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = "";
            state.successMessage = "";
        }
    },
    extraReducers: (builder) => {
        builder
            // 🆕 Admin seller management
            .addCase(get_sellers_admin.pending, (state) => {
                state.loader = true;
            })
            .addCase(get_sellers_admin.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.sellers = payload.sellers || payload.data || [];
                state.totalSeller = paginationTotal(payload, 'totalSellers');
            })
            .addCase(get_sellers_admin.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.error || 'Failed to fetch sellers';
            })

            .addCase(ban_seller.pending, (state) => {
                state.loader = true;
            })
            .addCase(ban_seller.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.successMessage = payload.message;
            })
            .addCase(ban_seller.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.error || 'Failed to ban seller';
            })

            .addCase(unban_seller.pending, (state) => {
                state.loader = true;
            })
            .addCase(unban_seller.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.successMessage = payload.message;
            })
            .addCase(unban_seller.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.error || 'Failed to unban seller';
            })

            .addCase(delete_seller.pending, (state) => {
                state.loader = true;
            })
            .addCase(delete_seller.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.successMessage = payload.message;
            })
            .addCase(delete_seller.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.error || 'Failed to delete seller';
            })

            .addCase(get_security_logs.pending, (state) => {
                state.loader = true;
            })
            .addCase(get_security_logs.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.securityLogs = payload.logs || payload.data || [];
                state.totalLogs = paginationTotal(payload, 'total');
            })
            .addCase(get_security_logs.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.error || 'Failed to fetch logs';
            })

            // Köhnə seller funksiyaları
            .addCase(get_seller_request.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.totalSeller = paginationTotal(payload, 'totalSeller');
                state.sellers = payload.sellers || payload.data || [];
            })
            .addCase(get_seller.fulfilled, (state, { payload }) => {
                state.seller = payload.seller;
            })
            .addCase(get_admin_seller_products.pending, (state) => {
                state.loader = true;
            })
            .addCase(get_admin_seller_products.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.seller = payload.seller || state.seller;
                state.sellerProducts = payload.products || [];
                state.sellerProductsPagination = payload.pagination || null;
                state.sellerProductsTotal = payload.totalProduct || payload.pagination?.total || 0;
            })
            .addCase(get_admin_seller_products.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.message || payload?.error || 'Seller məhsulları yüklənmədi';
            })
            .addCase(admin_delete_product.pending, (state) => {
                state.loader = true;
            })
            .addCase(admin_delete_product.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.sellerProducts = state.sellerProducts.filter(product => product._id !== payload.productId);
                state.sellerProductsTotal = Math.max(0, state.sellerProductsTotal - 1);
                if (state.sellerProductsPagination) {
                    const total = Math.max(0, (state.sellerProductsPagination.total || 0) - 1);
                    const limit = state.sellerProductsPagination.limit || 5;
                    const totalPages = Math.ceil(total / limit);
                    state.sellerProductsPagination = {
                        ...state.sellerProductsPagination,
                        total,
                        totalPages,
                        hasNextPage: state.sellerProductsPagination.page < totalPages,
                        hasPrevPage: state.sellerProductsPagination.page > 1
                    };
                }
                state.successMessage = payload.message;
            })
            .addCase(admin_delete_product.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.message || payload?.error || 'Məhsul deaktiv edilmədi';
            })
            .addCase(seller_status_update.fulfilled, (state, { payload }) => {
                state.seller = payload.seller;
                state.successMessage = payload.message;
            })
            .addCase(get_active_sellers.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.totalSeller = paginationTotal(payload, 'totalSeller');
                state.sellers = payload.sellers || payload.data || [];
            })
            .addCase(get_deactive_sellers.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.totalSeller = paginationTotal(payload, 'totalSeller');
                state.sellers = payload.sellers || payload.data || [];
            })
             .addCase(create_stripe_connect_account.pending, (state) => {
            state.loader = true;
        })
        .addCase(create_stripe_connect_account.fulfilled, (state) => {
            state.loader = false;
            state.successMessage = "Stripe Connect hesabı yaradılır...";
        })
        .addCase(create_stripe_connect_account.rejected, (state, { payload }) => {
            state.loader = false;
            state.errorMessage = payload?.error || "Stripe Connect hesabı yaradılmadı";
        })

        // ✅ STRIPE CONNECT ACCOUNT ACTIVE
        .addCase(active_stripe_connect_account.pending, (state) => {
            state.loader = true;
        })
        .addCase(active_stripe_connect_account.fulfilled, (state, { payload }) => {
            state.loader = false;
            state.successMessage = payload.message;
            state.seller = payload.seller; // əgər backend seller qaytarırsa
        })
        .addCase(active_stripe_connect_account.rejected, (state, { payload }) => {
            state.loader = false;
            state.errorMessage = payload?.error || "Stripe hesab aktiv edilmədi";
        })
            .addCase(get_activity_logs.pending, (state) => {
                state.loader = true;
            })
            .addCase(get_activity_logs.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.activityLogs = payload.logs || payload.data || [];
                state.totalActivityLogs = paginationTotal(payload, 'total');
            })
            .addCase(get_activity_logs.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.message || 'Something went wrong';
            });
            
    }
});

export const { messageClear } = sellerReducer.actions;
export default sellerReducer.reducer;
